import React from "react";

const FooterContainer = ({ children }) => {
  return (
    <div className={"h-10 bg-gray-800 content-center [&>img]:w-20 "}>
      {children}
    </div>
  );
};

export default FooterContainer;
